import _classCallCheck from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// ignore-string-externalization
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ThemeProvider } from 'styled-components';
import { loadMe, selectMe } from '../shared/store/me';
import ScrollToTop from '../shared/components/ScrollToTop';
import PageHead from '../shared/components/PageHead';
import { NavBar, USE_FRODOR_FOOTER } from '../../features/Layout/Nav';
import { Footer as FrodorFooter } from '../../features/Layout/Footer';
import { LayoutState } from '../../features/Layout';
import { darkTheme } from '../../features/Theme';
import { Track } from '../../features/Tracking';
import Layout from './Layout';
import Footer from './Footer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Root = /*#__PURE__*/function (_Component) {
  _inherits(Root, _Component);

  var _super = _createSuper(Root);

  function Root() {
    _classCallCheck(this, Root);

    return _super.apply(this, arguments);
  }

  _createClass(Root, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.loadMe();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var isPlain = /\.plain$/.test(this.props.location.pathname) || /plain/.test(this.props.location.search);

      var NavComponent = function NavComponent() {
        return /*#__PURE__*/_jsx(LayoutState, {
          children: /*#__PURE__*/_jsx(ThemeProvider, {
            theme: darkTheme,
            children: /*#__PURE__*/_jsx(NavBar, {
              forceState: _this.props.forceState,
              defaultMenuState: _this.props.defaultMenuState
            })
          })
        }); // legacy nav: <Navigation me={this.props.me} />
      };

      var FooterComponent = function FooterComponent() {
        return USE_FRODOR_FOOTER ? /*#__PURE__*/_jsx(ThemeProvider, {
          theme: darkTheme,
          children: /*#__PURE__*/_jsx(FrodorFooter, {})
        }) : /*#__PURE__*/_jsx(Footer, {});
      };

      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(PageHead, {}), /*#__PURE__*/_jsx(ScrollToTop, {
          children: /*#__PURE__*/_jsx(Track, {
            children: /*#__PURE__*/_jsx(Layout, {
              navigation: !isPlain && /*#__PURE__*/_jsx(NavComponent, {}),
              content: this.props.children,
              footer: !isPlain && /*#__PURE__*/_jsx(FooterComponent, {})
            })
          })
        })]
      });
    }
  }]);

  return Root;
}(Component);

var selector = createStructuredSelector({
  me: selectMe
});
var actions = {
  loadMe: loadMe
};
export default connect(selector, actions)(Root);